import { createContext, useContext } from "react"

interface ProductPageAddonTitlesContextType {
  titleByProductType: Record<string, string>
}

export const ProductPageAddonTitlesContext =
  createContext<ProductPageAddonTitlesContextType | null>(null)

export const useProductPageAddonTitlesContext = () => {
  const context = useContext(ProductPageAddonTitlesContext)
  if (!context) {
    throw new Error(
      "useProductPageAddonTitlesContext must be used within a ProductPageAddonTitlesProvider"
    )
  }
  return context
}
